import React, {Component} from 'react';
import './style.css'
class NutritionInfoTable extends Component {
    constructor(props){
        super(props);
        this.state={
            loading: false,
         
        }
    }
    updateValue =(e,item,nutritionName,rowIndex)=>{
        console.log(e,item)
        this.props.updateValue(e,nutritionName,item,rowIndex)
    }
    getRows = ()=>{
        return this.props.data.map((item,rowIndex)=>{
            const cels=[]
             this.props.headers.forEach((data,indx)=>{
                if(indx > 0){
                    const val = item[data.nutritionName] ? item[data.nutritionName] : ''
                    cels.push(<td key={indx}>
                        <input type="text" className="form-control col-xs" value={val} onChange={(e)=>this.updateValue(e,item,data.nutritionName,rowIndex)} />
                    </td>)
                }else{
                    cels.push(<th key={indx}>{item.name}</th>)
                }
            
            })
            return (<tr key={rowIndex}>
                
                {cels}
                </tr>)
        })
        
       
    }
    render() {
        
        return (
            <div className="row">
            <div className="col-md-12">
                <div className="table-responsive">
                    <section className="clearfix">
                        <div className="tab-content">
                            <div className="media">
                                <div className="panel panel-primary">
                                    <div className="panel-heading text-left">
                                        <h3 className="panel-title">Nutrition Info</h3>
                                    </div>
                                    <div className="panel-body">
                                    {/* <ReactTable style={{ textAlign: 'left',height:500 }}
                                            data={this.props.data}
                                            columns={this.props.headers}
                                            defaultPageSize={-1}
                                            className="-striped -highlight rtTable-Order"
                                            noDataText='No data found'
                                            showPagination={false}
                                        /> */}
                                    <div id="table-scroll" className="table-scroll">
                                    <table id="main-table" className="main-table">
                                        <thead>
                                        <tr>
                                       {this.props.headers.map(item=>(
                                           <th key={item.Header}>{item.Header}</th>
                                       ))}
                                        </tr>
                                        </thead>
                                        <tbody>

                                        {this.getRows()}
                                    
                                        </tbody>
                                        
                                        
                                       
                                    </table>
                                    </div>
                                    </div>
                                    <div className="from-group text-right">
                                        <button type="button" className="btn btn-success btn-xs" onClick={this.props.saveData}>Save</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            </div>
        </div>
                   
        );
    }
}
export default NutritionInfoTable;


// WEBPACK FOOTER //
// ./src/components/SchoolAdmin/Nutrition/NutritionInfoTable.jsx